import { TXCarouselTemplate } from "../../../types/common/templates.types";

export const X_CAROUSEL_TEMPLATE_1: TXCarouselTemplate = {
  "Carousel Vide": {
    template: [
      {
        name: "XCarousel",
        props: {
          all: {
            columns: 1,
          },
        },
      },
    ],
  },
};
